"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsUpdateFeatureMutation = void 0;
const useModelsMutation_1 = require("./useModelsMutation");
function useModelsUpdateFeatureMutation(accountNumber, featureCollectionId) {
    return useModelsMutation_1.useModelsMutation(accountNumber, 'PUT', ({ id }) => `/feature-collections/${featureCollectionId}/features/${id}`, undefined, { featureCollection: featureCollectionId });
}
exports.useModelsUpdateFeatureMutation = useModelsUpdateFeatureMutation;
//# sourceMappingURL=useModelsUpdateFeatureMutation.js.map